import React from 'react';
import Faq from '../components/Faq';
import Brand from '../components/Brand';
import NewsLetter from '../components/NewsLetter';

function InfoPage() {
    return (
        <main>
            {/* Breadcrumb Section */}
            <section className="breadcrumb-area breadcrumb-bg" style={{ backgroundImage: "url('img/bg/breadcrumb_bg.jpg')" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h2 className="title">Informations</h2>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="/">Accueil</a></li>
                                        <li className="breadcrumb-item active" aria-current="page">Informations</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            {/* Dog Size Cheat Sheet Section */}
            <section className="dog-size-guide-area" style={{ padding: '100px 0', backgroundColor: '#fff' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-title text-center mb-50">
                                <h5 className="sub-title">Guide des Tailles</h5>
                                <h2 className="title">Comment Mesurer Votre Chien</h2>
                                <p>Utilisez ce guide pour déterminer la taille parfaite pour votre chien</p>
                            </div>
                            <div className="size-guide-img text-center">
                                <img
                                    src="img/images/cheat-sheet-sizes.jpg"
                                    alt="Guide des tailles pour chiens"
                                    style={{
                                        maxWidth: '100%',
                                        height: 'auto',
                                        borderRadius: '10px',
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <Faq afterElment="faq-area" />
            {/* <Brand /> */}
            <NewsLetter />

        </main>
    );
}

export default InfoPage;
